import { Divider } from "antd";
import React, { useEffect, useState } from "react";
import "./Surveys.css";
import { useCurrentLanguage } from "../../hooks/useCurrentLanguage";
import TEXT from "../../utils/text/surveys.json";

//Components
import PageTitleSection from "../../components/reusable/PageTitleSection/PageTitleSection";
import BIDButton from "../../components/reusable/BIDButton/BIDButton";
import Regional from "../../components/Surveys/regional/Regional";
import National from "../../components/Surveys/national/National";
import NationalMig from "../../components/Surveys/nationalMig/NationalMig";

//text
import miscTEXT from "../../utils/text/misc.json";

const tabs = [
  {
    key: "reg", //regional
  },
  {
    key: "nac", //national
  },
  {
    key: "nac_mig", //national migrants
  }
]

const values = {
  "reg": {
    "title": "title",
    "description": "description",
    "url": "https://publications.iadb.org/es/mas-alla-de-las-fronteras-estigmas-y-desafios-en-la-integracion-de-las-mujeres-migrantes-en-america"
  },
  "nac": {
    "title": "title_nac",
    "description": "description_nac",
    "url": "https://publications.iadb.org/es/mas-alla-de-las-fronteras-estigmas-y-desafios-en-la-integracion-de-las-mujeres-migrantes-en-america"
  },
  "nac_mig": {
    "title": "title_nac_mig",
    "description": "description_nac_mig",
    "url": "https://publications.iadb.org/es/mas-alla-de-las-fronteras-estigmas-y-desafios-en-la-integracion-de-las-mujeres-migrantes-en-america"
  }
}

export default function Surveys() {
  const { language } = useCurrentLanguage();
  const [currentTab, setCurrentTab] = useState("reg");

  useEffect(() => {
    // 👇️ scroll to top on page load
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    window.dataLayer.push({
      event: 'pageview'
    });

    const hash = window.location.hash;

    // Extract the query string part (after '?')
    const queryString = hash.substring(hash.indexOf('?') + 1);

    // Create URLSearchParams object with the query string
    const queryParams = new URLSearchParams(queryString);

    // Get the 'survey' query parameter
    const surveyParam = queryParams.get('survey');
    console.log(surveyParam);
    // If the 'survey' query parameter is set the state to reg
    if (!surveyParam) {
      setCurrentTab('reg');
    } else {
      // Set the survey state
      setCurrentTab(surveyParam);
    }
  }, []);

  //handle tab click
  const handleClick = (key) => setCurrentTab(key);
  

  return (
    <div className="surveys-page-container">
      <div className="rp-menu">
        {tabs.map((i) => {
          return (
            <button
              key={i.key}
              className={
                "rp-menu-item" +
                (currentTab === i.key ? " rp-menu-selected" : "")
              }
              onClick={() => handleClick(i.key)}
            >
              <span>{TEXT[i.key][language]}</span>
            </button>
          );
        })}
      </div>
      <Divider className="divider-full-screen" />
      <div className="surveys-page-title">
          <PageTitleSection
            title={TEXT[values[currentTab]['title']][language]}
            descriptionParagraphs={TEXT[values[currentTab]['description']][language]}
            image="surveys.png"
            callToActionElement={
              <div className="data-page-report-button">
                <a
                  href={values[currentTab]['url']}
                  target={"_blank"}
                  rel="noreferrer"
                >
                  <BIDButton
                    text={miscTEXT["downloadLatestReport"][language]}
                    type={"light"}
                    size={"medium"}
                  />
                </a>
              </div>
            }
          />
        </div>

      {currentTab === "reg" ? (
        <Regional />
      ) : currentTab === "nac" ? (
        <National />
      ) : (
        <NationalMig />
      )}
    </div>
  );
}
